"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Operation = (function () {
    function Operation() {
    }
    Operation.prototype.disposeTransientArrays = function (inferenceArrays, gradientArrays) { };
    Operation.prototype.dispose = function () { };
    return Operation;
}());
exports.Operation = Operation;



//////////////////
// WEBPACK FOOTER
// ./node_modules/deeplearn/dist/graph/ops/op.js
// module id = 3
// module chunks = 0